import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/journeySlice";
import journeyApis from "src/api/journey";
import { common } from "src/types";
import { constants } from "src/constants/common";

const GetCyclesSaga = function* GetCyclesSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      journeyApis.getCycles,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getCyclesSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getCyclesError(
        error instanceof Error ? error.message : "Unknown error occurred"
      )
    );
    reject(error);
  }
};

const MarkAttendanceSaga = function* MarkAttendanceSaga({
  payload: { resolve, reject, payload, extra },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      journeyApis.updateAttendance,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.markAttendanceSuccess(extra));
    resolve(response);
  } catch (error) {
    yield put(
      actions.markAttendanceFailed(
        error instanceof Error ? error.message : "Unknown error occurred"
      )
    );
    reject(error);
  }
};

const GetCycleDocumentsSaga = function* GetCycleDocumentsSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      journeyApis.getCycleDocuments,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getCycleDocumentsSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getCycleDocumentsError(
        error instanceof Error ? error.message : "Unknown error occurred"
      )
    );
    reject(error);
  }
};

const rescheduleCycleSaga = function* rescheduleCycleSaga({
  payload: { resolve, reject, payload, extra },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      journeyApis.updateAttendance,
      payload
    );
    if (response?.code === "-1") {
      // throw new Error();
      // TODO: seesion expire
      throw new Error("Session Expire");
    } else if (response?.code === "0") {
      throw new Error(response?.code);
    }
    yield put(actions.rescheduleCycleSuccess(extra));
    resolve(response);
  } catch (error) {
    reject(error);
    yield put(
      actions.rescheduleCycleFailed(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

const updatePatientVisitSaga = function* updatePatientVisitSaga({
  payload: { resolve, reject, payload, extra },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      journeyApis.updatePatientVisit,
      payload
    );

    if (response?.code === "-1") {
      throw new Error("Session Expire");
    } else if (response?.code === "0") {
      throw new Error(response?.code);
    }
    yield put(actions.updatePatientVisitSuccess(extra));
    resolve(response);
  } catch (error) {
    console.log("error of updatePatientVisitSaga : ", error);
    reject(error);
    yield put(
      actions.updatePatientVisitFailed(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

const createFirstCycleSaga = function* createFirstCycleSaga({
  payload: { resolve, reject, payload, extra },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      journeyApis.createFirstCycle,
      payload
    );

    if (response?.code === "-1") {
      throw new Error("Session Expire");
    } else if (response?.code === "0") {
      throw new Error(response?.code);
    }
    yield put(actions.createFirstCycleSuccess(extra));
    resolve(response);
  } catch (error) {
    console.log("error of createFirstCycleSaga : ", error);
    reject(error);
    yield put(
      actions.createFirstCycleFailed(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

const getDrugsSaga = function* getDrugsSaga({
  payload: { resolve, reject, payload, extra },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      journeyApis.getDrugs,
      payload
    );

    if (response?.code === "-1") {
      throw new Error("Session Expire");
    } else if (response?.code === "0") {
      throw new Error(response?.code);
    }
    yield put(actions.getDrugsSuccess(extra));
    resolve(response);
  } catch (error) {
    console.log("error of getDrugsSaga : ", error);
    reject(error);
    yield put(
      actions.getDrugsFailed(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

export default function* journeySaga() {
  yield all([
    takeEvery(actions.getCyclesRequest, GetCyclesSaga),
    takeEvery(actions.markAttendanceRequest, MarkAttendanceSaga),
    takeEvery(actions.getCycleDocumentsRequest, GetCycleDocumentsSaga),
    takeEvery(actions.rescheduleCycleRequest, rescheduleCycleSaga),
    takeEvery(actions.createFirstCycleRequest, createFirstCycleSaga),
    takeEvery(actions.updatePatientVisitRequest, updatePatientVisitSaga),
    takeEvery(actions.getDrugsRequest, getDrugsSaga),
  ]);
}
